import { Controller } from 'react-hook-form';
import { InputText, Select } from '@ui/src';
import { TariffType } from '../../hoc/tariffs/types';
import { TariffsCreateTariffFormTypes } from './types';

import cn from './tariffs.module.css';

const TariffsCreateTariffForm = ({
  control,
  errors,
  riskScoreRanges,
}: TariffsCreateTariffFormTypes) => (
  <div className={cn.createTariffForm}>
    <div className={cn.createTariffFormGroup}>
      <Controller
        control={control}
        name="name"
        defaultValue=""
        render={({ field: { onChange, value } }) => (
          <InputText
            name="name"
            placeholder="Enter Tariff name"
            onChange={onChange}
            value={value}
            title="Tariff name"
            error={errors?.name?.message}
            tabIndex={0}
          />
        )}
      />
    </div>
    <div className={cn.createTariffFormGroup}>
      <Controller
        control={control}
        name="riskScoreRangeId"
        render={({ field: { onChange, value } }) => (
          <Select
            list={riskScoreRanges?.map((item) => ({
              name: item.name,
              value: item.id,
              description: `from ${item.rangeStart} to ${item.rangeEnd}`,
            }))}
            placeholder="Choose risk score"
            name="riskScoreRangeId"
            value={value}
            onChange={onChange}
            title="Risk score"
            selectWrapperClassName={`${cn.createTariffFormSelect} ${
              errors?.riskScoreRangeId?.message
                ? cn.createTariffFormSelectError
                : ''
            }`}
            tabIndex={0}
          />
        )}
      />
      {errors?.riskScoreRangeId?.message && (
        <div className={cn.error}>{errors?.riskScoreRangeId?.message}</div>
      )}
    </div>
    <div className={cn.createTariffFormGroup}>
      <Controller
        control={control}
        name="type"
        defaultValue={TariffType.INDIVIDUAL}
        render={({ field: { onChange, value } }) => (
          <Select
            list={[
              {
                name: 'Individual',
                value: TariffType.INDIVIDUAL,
              },
              {
                name: 'Corporate',
                value: TariffType.CORPORATE,
              },
            ]}
            placeholder="Choose type"
            name="type"
            title="Type"
            value={value}
            onChange={onChange}
            selectWrapperClassName={cn.createTariffFormSelect}
            tabIndex={0}
          />
        )}
      />
    </div>
  </div>
);

export default TariffsCreateTariffForm;
